// Static, hand-maintained list of Galerie projects (across all brands — Corso,
// Village Park, and future ones) for the "what's next" sections on the Home,
// Corso, and Development pages. No database — edit this file directly to add,
// remove, or update a project.
//
// brand: which Galerie brand the project belongs to, e.g. "Corso", "Village Park".
// status: "in-development" | "open"
// date: for in-development projects, the target opening date/quarter (e.g. "2026");
//        for open projects, the date it opened — used to sort completed projects
//        newest-first. Use a sortable value (a year, or "2026-Q2").
// imgId: matches an id set on an <img>, populated at runtime via getAllPhotos()
//        from Firebase Storage at `galerie_projects/${imgId}.webp` — upload the
//        real photo there (same convention as the rest of the site's imagery)
//        and it will automatically replace placeholderImg below.
// placeholderImg: a static image already bundled with the site, shown until a
//        real photo is uploaded to Storage. TODO: replace these with real
//        renderings/photos per project.

import corso_hero from "../Images/home/project_pipeline/home_project_pipeline_atlanta_expansion.webp";
import collection_hero from "../Images/home/project_pipeline/home_project_pipeline_druid_hills.webp";
import development_hero from "../Images/home/project_pipeline/home_project_pipeline_chevy_chase.webp";
import carousel_23 from "../Images/home/project_pipeline/home_project_pipeline_vpm2.webp";
import carousel_1 from "../Images/home/project_pipeline/home_project_pipeline_atlanta.webp";

export const galerie_projects = [
  {
    id: "chevy-chase",
    name: "Corso Chevy Chase",
    brand: "Corso",
    location: "Chevy Chase, MD",
    status: "under-construction",
    date: "TBD", // TODO: set target opening date/quarter
    blurb:
      "A New Standard In A Storied Town. 400+ luxury residences seated in the heart of Chevy Chase, Maryland",
    link: "https://www.corsoresidences.com/chevy-chase/",
    imgId: "galerie-project-chevy-chase",
    placeholderImg: development_hero,
  },
  {
    id: "atlanta-expansion",
    name: "Corso Atlanta's South Tower Expansion",
    brand: "Corso",
    location: "Atlanta, GA",
    status: "under-construction",
    date: "TBD", // TODO: set target opening date/quarter
    blurb:
      "A New Height of Excellence. A redefining additon, spanning eleven stories and over one hundred private residences.",
    link: "https://www.corsoresidences.com/atlanta/",
    imgId: "catl2-westpersp",
    placeholderImg: corso_hero,
  },
  {
    id: "druid-hills",
    name: "Corso Druid Hills",
    brand: "Corso",
    location: "Atlanta, GA",
    status: "in-development",
    date: "TBD", // TODO: set target opening date/quarter
    blurb:
      "A New Chapter For An Historic Estate. Corso Druid Hills reimagines the storied Briarcliff campus as a hub of wellness and hospitality",
    link: "https://www.corsoresidences.com/druid-hills/",
    imgId: "galerie-project-druid-hills",
    placeholderImg: collection_hero,
  },
  {
    id: "vpm2",
    name: "Village Park Milton Phase 2",
    brand: "Village Park",
    location: "Alpharetta, GA",
    status: "open",
    date: "2022", // TODO: confirm actual opening year
    blurb:
      "A grand expansion to an award-winning community, introducing new wellness spaces, restaurant venues, and retail storefronts.",
    link: "https://villageparkseniorliving.com/communities/village-park-milton/",
    imgId: "galerie-project-vpm2",
    placeholderImg: carousel_23,
  },
  {
    id: "catl",
    name: "Corso Atlanta",
    brand: "Corso",
    location: "Atlanta, GA",
    status: "open",
    date: "2021", // TODO: confirm actual opening year
    blurb:
      "Named the #1 Senior Living Community in America by Seniorly.",
    link: "https://www.corsoresidences.com/atlanta/",
    imgId: "galerie-project-catl",
    placeholderImg: carousel_1,
  },
];

// Active projects (any non-"open" status — "in-development", "expansion-underway",
// etc.) first in their declared order, then open projects newest-first.
export function sortGalerieProjects(projects) {
  const active = projects.filter((p) => p.status !== "open");
  const open = projects
    .filter((p) => p.status === "open")
    .sort((a, b) => String(b.date).localeCompare(String(a.date)));
  return [...active, ...open];
}
